import { createRouter, createWebHistory } from 'vue-router'
import { initKeycloak, isAuthenticated, login } from '../keycloak'

const routes = [
    { path: '/', name: 'landing', component: () => import('../views/LandingView.vue') },
    { path: '/app', name: 'finder', component: () => import('../views/FinderView.vue'), meta: { requiresAuth: true } },
    { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach(async (to) => {
    if (!to.meta.requiresAuth) return true

    await initKeycloak()

    if (isAuthenticated()) return true

    login()
    return false
})

export default router
